export const COVERAGE_AVAILABLE = [
  {
    value: 'patient_initials_dob',
    label: 'Patient Initials & DOB',
    group: 'Patient Info',
  },
  // {
  //   value: "patient_id",
  //   label: "Patient ID",
  // },
  {
    value: "bi_case_id",
    label: "Case ID",
    group: "Patient Info",
  },
  {
    value: "received_at",
    label: "Date Received",
    group: "Patient Info",
  },
  {
    value: "product_name",
    label: "Product Type",
    group: "Patient Info",
  },
  {
    value: "review_type",
    label: "Review Type",
    group: "Patient Info",
  },
  {
    value: "qty",
    label: "Qty",
    group: "Utilization Review",
  },
  {
    value: "refills",
    label: "Refill Number",
    group: "Utilization Review",
  },
  {
    value: "bi_completed",
    label: "BI Completed",
    group: "Utilization Review",
  },
  {
    value: "pa_required",
    label: "PA Required",
    group: "Utilization Review",
  },
  {
    value: "payer",
    label: "Insurance Name",
    group: "Patient Info",
  },
  {
    value: "insurance_type",
    label: "Insurance Type",
    group: "Patient Info",
  },
   {
    value: "released",
    label: "Released",
    group: "Patient Info",

  },

  // {
  //   value: "region",
  //   label: "Region",
  // },
  // {
  //   value: "territory",
  //   label: "Territory",
  // },
  // {
  //   value: "state",
  //   label: "State",
  // },

  // {
  //   value: "medical_coverage_status",
  //   label: " Medical Coverage (Buy & Bill)",
  // },
  {
    value: "pharmacy_coverage_status",
    label: "Case Status",
    group: "pharmacyCoverage",
  },
  {
    value: "physician",
    label: "Prescriber",
    group: "Patient Info",
  },
  //  {
  //   value: '',
  //   label: 'Copay Status',
  // },
  // {
  //   value: '',
  //   label: 'Provide Treatment Status',
  // },
  // {
  //   value: "",
  //   label: "Next Step",
  //   group: "pharmacyCoverage",
  // },
];
export const COVERAGE_MANUFACTURE_AVAILABLE = [
  {
    value: "",
    label: "Patient Name",
  },
  {
    value: "",
    label: "Patient ID",
  },
  {
    value: "",
    label: "Case ID",
  },
  {
    value: "",
    label: "Case type",
  },
  {
    value: "",
    label: "BI Completed",
  },
  {
    value: "",
    label: "Payer",
  },
  {
    value: "",
    label: "Provider",
  },
  {
    value: "",
    label: "MEDICAL COVERAGE (BUY & BILL)",
  },
  {
    value: "",
    label: " PHARMACY COVERAGE (SPECIALTY PHARMACY)",
  },
  {
    value: "",
    label: "Provide Treatment Status",
  },
  {
    value: "",
    label: "Patient Activation Status",
  },
  {
    value: "",
    label: "Indiction",
  },
  {
    value: "",
    label: "Confirm Indiction",
  },
  {
    value: "",
    label: "KAM/FAM Note",
  },
];
export const ACTION_REQUIRED = [
  {
    value: 'patient_initials_dob',
    label: 'Patient Initials & DOB',
    group: 'Patient Info',
  },
  // {
  //   value: "patient_id",
  //   label: "Patient ID",
  //   group: 'Patient Info',
  // },
  {
    value: "bi_case_id",
    label: "Case ID",
    group: 'Patient Info',
  },
  {
    value: "received_at",
    label: "Date Received",
    group: "Patient Info",
  },
  // {
  //   value: "",
  //   label: "Auto-Transfer",
  // },
  {
    value: "clinical_received",
    label: "Clinicals Received",
    group: "Utilization Review",
  },
  {
    value: "lomn_received",
    label: "LOMN",
    group: "Utilization Review",
  },
 {
    value: "review_type",
    label: "Review Type",
    group: "Utilization Review",
  },
  {
    value: "qty",
    label: "Qty",
    group: "Utilization Review",
  },
  {
    value: "refills",
    label: "Refill Number",
    group: "Utilization Review",
  },
  {
    value: "bi_completed",
    label: "BI Completed",
    group: "Utilization Review",
  },
  {
    value: "pa_required",
    label: "PA Required",
    group: "Utilization Review",
  },
  {
    value: "insurance_type",
    label: "Insurance Type",
    group: "Patient Info",
  },
  {
    value: "missing_info",
    label: "Missing Information",
    group: "Patient Info",
  },
   {
    value: "released",
    label: "Released",
    group: "Patient Info",

  },

  // {
  //   value: "region",
  //   label: "Region",
  // },
  // {
  //   value: "territory",
  //   label: "Territory",
  // },
  // {
  //   value: "state",
  //   label: "State",
  // },
  // {
  //   value: "medical_coverage_status",
  //   label: "Medical Coverage (Buy & Bill)",
  // },
  {
    value: "pharmacy_coverage_status",
    label: "Case Status",
    group: "pharmacyCoverage",
  },
  {
    value: "physician",
    label: "Prescriber",
    group: "Patient Info",
  },
  // {
  //   value: "",
  //   label: " Next Step",
  //   group: "pharmacyCoverage",
  // },
];
export const ACTION_MANUFACTURE_REQUIRED = [
  {
    value: "",
    label: "Patient Name",
  },
  {
    value: "",
    label: "Patient ID",
  },
  {
    value: "",
    label: "BI Case ID",
  },
  {
    value: "",
    label: "Case type",
  },
  {
    value: "",
    label: "BI Completed",
  },
  {
    value: "",
    label: "Insurance Type",
  },
  {
    value: "",
    label: "Provider",
  },
  {
    value: "",
    label: "MEDICAL COVERAGE (BUY & BILL)",
  },
  {
    value: "",
    label: " PHARMACY COVERAGE (SPECIALTY PHARMACY)",
  },
  {
    value: "",
    label: "Next Steps",
  },
  {
    value: "",
    label: "Patient Activation Status",
  },
  {
    value: "",
    label: "Indiction",
  },
  {
    value: "",
    label: "Confirm Indiction",
  },
  {
    value: "",
    label: "KAM/FAM Note",
  },
];
export const SPECIALITY_PHARMACY = [
  {
    value: 'patient_initials_dob',
    label: 'Patient Initials & DOB',
    group: 'Patient Info',
  },
  // {
  //   value: "patient_id",
  //   label: "Patient ID",
  // },
  {
    value: "bi_case_id",
    label: "Case ID",
    group: 'Patient Info',
  },
  {
    value: "sp_transferred_to",
    label: "SP Transferred to",
    group: "Patient Info",
  },
  // {
  //   value: "drug_name",
  //   label: "Product",
  // },

  // {
  //   value: "region",
  //   label: "Region",
  // },
  // {
  //   value: "territory",
  //   label: "Territory",
  // },
  // {
  //   value: "state",
  //   label: "State",
  // },

  {
    value: "sp_status",
    label: "Pharmacy (SP) Status",
    group: "Patient Info",
  },

  {
    value: "sp_substatus",
    label: "Pharmacy SP Sub Status",
    group: "Patient Info",
  },
  // {
  //   value: 'provider_treatment_status',
  //   label: 'Provide Treatment Status',
  // },
  // {
  //   value: '',
  //   label: 'Carrier',
  // },
  // {
  //   value: '',
  //   label: 'Sales Rep Note',
  //   group: "Patient Info",
  // },
  //  {
  //   value: 'clinical_received',
  //   label: 'Clinical Received',
  //   group: "Patient Info",
  // },
  // {
  //   value: 'lomn_received',
  //   label: 'LOMN',
  //   group: "Patient Info",
  // },
  {
    value: 'review_type',
    label: 'Review Type',
    group: "Patient Info",
  },
  {
    value: 'payer',
    label: 'Insurance Name',
    group: "Patient Info",
  },
  {
    value: 'insurance_type',
    label: 'Insurance Type',
    group: "Patient Info",
  },
  {
    value: 'qty',
    label: 'QTY',
    group: "Patient Info",
  },
  // {
  //   value: 'released',
  //   label: 'Released',
  //   group: "Patient Info",
  // },
  {
    value: "provider",
    label: "Prescriber",
    group: 'Patient Info',
  },
  {
    value: "date_transferred",
    label: "Date Order Transferred",
    group: "Specialty Pharmacy",
  },
  {
    value: "pending_shipment_date",
    label: "Scheduled Delivery Date",
    group: "Specialty Pharmacy",
  },
  {
    value: "date_shipped",
    label: "Date Order Shipped",
    group: "Specialty Pharmacy",
  },
  {
    value: "fill_number",
    label: "Fill Number",
    group: "Specialty Pharmacy",
  },
  {
    value: "qty_transferred",
    label: "QTY Transferred",
    group: "Specialty Pharmacy",
  },
  {
    value: 'refills',
    label: 'Refills',
    group: "Specialty Pharmacy",
  },
  {
    value: "qty_dispensed",
    label: "QTY dispensed",
    group: "Specialty Pharmacy",
  },
  {
    value: "oop_cost",
    label: "Patient OOP cost",
    group: "Specialty Pharmacy",
  },
  // {
  //   value: "dispense_refill",
  //   label: "Dispense & Refill",
  //   group: 'Patient Info',
  // },
];
export const PENDING_TABLE = [
  {
    value: 'patient_initials_dob',
    label: 'Patient Initials & DOB',
    group: 'Patient Info',
  },
  // {
  //   value: "patient_id",
  //   label: "Patient ID",
  //   group: 'Patient Info',
  // },
  {
    value: "bi_case_id",
    label: "Case ID",
    group: 'Patient Info',
  },
  // {
  //   value: "",
  //   label: "Auto-Transfer",
  // },
  // {
  //   value: "drug_name",
  //   label: "Product",
  // },
  //
  {
    value: 'review_type',
    label: 'Review Type',
    group: "Specialty Pharmacy",
  },
  {
    value: 'released',
    label: 'Released',
    group: "Specialty Pharmacy",
  },
  {
    value: "bi_completed",
    label: "BI Completed",
    group: 'Patient Info',
  },

  {
    value: "pa_required",
    label: "PA Required",
    group: 'Patient Info',
  },
  {
    value: "pa_status",
    label: "PA Status",
    group: 'Patient Info',
  },
  {
    value: 'clinical_received',
    label: 'Clinical Received',
    group: "Specialty Pharmacy",
  },

  {
    value: "insurance_type",
    label: "Primary Insurance Type",
    group: 'Patient Info',
  },

  {
    value: 'refills',
    label: 'Refills',
    group: "Specialty Pharmacy",
  },
  {
    value: 'qty',
    label: 'QTY',
    group: "Specialty Pharmacy",
  },
  {
    value: 'lomn_received',
    label: 'LOMN Received',
    group: "Specialty Pharmacy",
  },
  // {
  //   value: "territory",
  //   label: "Territory",
  // },
  // {
  //   value: "state",
  //   label: "State",
  // },
  // {
  //   value: "medical_coverage_status",
  //   label: " Medical Coverage (Buy & Bill)",
  // },
  {
    value: "pharmacy_coverage_status",
    label: "Case Status",
    group: "pharmacyCoverage",
  },
  {
    value: "provider",
    label: "Prescriber",
    group: 'Patient Info',
  },
  // {
  //   value: "",
  //   label: " Next Step",
  //   group: "pharmacyCoverage",
  // },]
];
export const COPAY_TABLE = [
  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },

  {
    value: "patient_id",
    label: "Patient ID",
  },
  {
    value: "bi_case_id",
    label: "Case ID",
  },
  {
    value: "bi_completed",
    label: "BI Completed",
  },
  {
    value: "date_of_service",
    label: "Date of Service",
  },
  {
    value: "insurance_name",
    label: "Insurance Name",
  },
  {
    value: "practice_name",
    label: "Practice Name",
  },
  // {
  //   value:'practice_name',
  //   label:'Practice Name'
  // },
  {
    value: "provider",
    label: "Provider",
  },
  {
    value: "submitted_by",
    label: "Submitted By",
  },
  {
    value: "copay_status",
    label: "Copay Status",
  },
  {
    value: "high_pt_cost_share",
    label: "High Pt Cost Share",
  },
  {
    value: "days_until_copay_claim_filed",
    label: "Days Until Copay Claim Can be Filed",
  },
  // {
  //   value:'drug_name',
  //   label:'Product'
  // },
  // //
  // {
  //   value: 'bi_submitted',
  //   label: 'BI Submitted',
  // },
  // {
  //   value:'drug_name',
  //   label:'Product'
  // },
  // //
  // {
  //   value: 'bi_submitted',
  //   label: 'BI Submitted',
  // },

  // {
  //   value: 'patient_name',
  //   label: 'Patient Name',
  // },
  // {
  //   value: 'payer',
  //   label: 'Primary Insurance Type',
  // },
  // {
  //   value: 'provider',
  //   label: 'Provider',
  // },
  // {
  //   value: 'medical_coverage_status',
  //   label: ' Medical Coverage (Buy & Bill)',
  // },
  // {
  //   value: 'pharmacy_coverage_status',
  //   label: 'Pharmacy Coverage (Specialty Pharmacy)',
  // },
  //  {
  //   value: 'copay_status',
  //   label: 'Copay Status',
  // },
  // {
  //   value: 'provider',
  //   label: 'Provider',
  // },
  // {
  //   value: 'medical_coverage_status',
  //   label: ' Medical Coverage (Buy & Bill)',
  // },
  // {
  //   value: 'pharmacy_coverage_status',
  //   label: 'Pharmacy Coverage (Specialty Pharmacy)',
  // },
  //  {
  //   value: 'copay_status',
  //   label: 'Copay Status',
  // },
  // {
  //   value: '',
  //   label: ' Next Step',
  // },
];
export const SPECIALITY_MANUFACTURE_PHARMACY = [
  {
    value: "",
    label: "Patient Name",
  },
  {
    value: "",
    label: "Patient ID",
  },
  {
    value: "",
    label: "BI Case ID",
  },
  {
    value: "",
    label: "Provider",
  },

  {
    value: "",
    label: "SP Transferred To",
  },
  {
    value: "",
    label: "Date Transferred",
  },
  {
    value: "",
    label: "Status Update",
  },
  {
    value: "",
    label: "Date Shipped",
  },
  {
    value: "",
    label: "Carrier",
  },
  {
    value: "",
    label: "Tracking Number",
  },
  {
    value: "",
    label: "Pharmacy (SP) Status",
  },
  {
    value: "",
    label: "Provide Treatment Status",
  },
  {
    value: "",
    label: "Indiction",
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: "",
    label: "KAM/FAM Note",
  },
];
export const PENDING_MANUFACTURE_TABLE = [
  {
    value: "",
    label: "Patient Name",
  },
  {
    value: "",
    label: "Patient ID",
  },
  {
    value: "",
    label: "BI Case ID",
  },
  {
    value: "",
    label: "Case Type	",
  },
  {
    value: "",
    label: "BI Submitted",
  },
  {
    value: "",
    label: "BI Completed",
  },
  {
    value: "",
    label: "Payer",
  },
  {
    value: "",
    label: "Provider",
  },
  {
    value: "",
    label: "MEDICAL COVERAGE (BUY & BILL)",
  },
  {
    value: "",
    label: " PHARMACY COVERAGE (SPECIALTY PHARMACY)",
  },
  {
    value: "",
    label: "Provide Treatment Status",
  },
  {
    value: "",
    label: "Indiction",
  },
  {
    value: "",
    label: "Confirm Indiction",
  },
  {
    value: "",
    label: "KAM/FAM Note",
  },
];
